import { Header } from "../components/header/Header";

export function Main() {
    return (
        <>
        <Header />
        <div className="flex justify-center">
            <h1>This is a main</h1>
        </div>
        </>
    );
}